module.exports = __webpack_public_path__ + "static/media/fl-logo.a7918c4d.webp";